import * as ActionTypes from "./actionTypes";

export const receiveMetadataSnapshot = (key, value) => {
  return {
    type: ActionTypes.RECEIVE_METADATA_SNAPSHOT,
    key,
    value
  };
};
